import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';
import { ICommand } from '@/modules/canvas/commands/ICommand';

type State = {
  past: ICommand[];
  future: ICommand[];
  hasUndo: boolean;
  hasRedo: boolean;
};

const INITIAL_STATE: State = {
  hasUndo: false,
  hasRedo: false,
  past: [],
  future: [],
};

type Actions = {
  setHasUndo(value: boolean): void;
  setHasRedo(value: boolean): void;
  getHasUndo(): boolean;
  getHasRedo(): boolean;
  reset(): void;
};

export const useHistoryStore = create<State & Actions>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setHasUndo(value: boolean) {
        set(
          () => ({
            hasUndo: value,
          }),
          undefined,
          { type: 'setHasUndo' },
        );
      },

      setHasRedo(value: boolean) {
        set(
          () => ({
            hasRedo: value,
          }),
          undefined,
          { type: 'setHasRedo' },
        );
      },

      getHasUndo() {
        return useHistoryStore.getState().hasUndo;
      },

      getHasRedo() {
        return useHistoryStore.getState().hasRedo;
      },

      reset: () => {
        set(INITIAL_STATE, undefined, {
          type: 'reset',
        });
      },
    }),
    { store: 'historyStore', ...DEVTOOLS_OPTIONS },
  ),
);
